import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

import localAxios from "axios";

import { replayWelcome } from "../KodeWelcome/KodeWelcome";

const styles = (theme) => ({
  label: {
    color: theme.palette.text.disabled,
    display: "block",
    marginBottom: theme.spacing(0.5),
  },
  value: {
    display: "block",
    marginBottom: theme.spacing(3),
    wordBreak: "break-all",
  },
  programme: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  attribution: {
    color: theme.palette.text.disabled,
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(1),
    display: "block",
  },
});

/**
 * Внешних ссылок здесь больше нет: gitter, GitHub и LinkedIn в закрытом контуре
 * QA гарантированно мертвы. Атрибуция MIT — простым текстом: лицензия требует
 * уведомления, а не гиперссылки (сам LICENSE остаётся в репозитории).
 */
class AllureDockerInfoDialog extends Component {
  state = {
    version: null,
  };

  // Признак «запрос уже отправляли» держим ОТДЕЛЬНО от значения и вне state:
  // перерисовывать компонент он не должен. Раньше признаком служило само
  // version, и пустая строка оставляла условие открытым — setState вызывал
  // обновление, обновление слало новый запрос, ответ снова писал пустоту.
  // На проде это дало 4231 запрос к config.json на одной открытой странице.
  // Пустая строка там не случайность: VERSION не передаётся build-arg'ом в
  // docker/Dockerfile, поэтому ui_version пуст и run.sh кладёт "version": "".
  configRequested = false;

  componentDidMount() {
    this.getConfig();
  }

  getConfig = () => {
    if (this.configRequested) {
      return;
    }
    this.configRequested = true;
    const axios = localAxios.create();
    axios
      .get(`${process.env.PUBLIC_URL}/config.json`)
      .then((response) => {
        // Пустое значение показываем как unknown: пустая строка в диалоге
        // выглядит как сломанная вёрстка, а не как отсутствующая версия.
        this.setState({ version: response.data.version || "unknown" });
      })
      .catch(() => {
        this.setState({ version: "NOT_FOUND" });
      });
  };

  handleCloseDialog = () => {
    this.props.handleCloseDialog();
  };

  handleReplayIntro = () => {
    replayWelcome();
    window.location.reload();
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleCloseDialog}
        aria-labelledby="info-dialog-title"
      >
        <DialogTitle id="info-dialog-title">About</DialogTitle>
        <DialogContent>
          <Typography variant="overline" className={classes.label}>
            Programme
          </Typography>
          <span className={`${classes.value} ${classes.programme}`}>
            KODE AI Transformation
          </span>

          <Typography variant="overline" className={classes.label}>
            Service
          </Typography>
          <Typography variant="body2" className={classes.value}>
            KODE QA Reports — Allure reports for every service, with nested project
            folders and drag &amp; drop.
          </Typography>

          <Typography variant="overline" className={classes.label}>
            UI version
          </Typography>
          <Typography variant="body2" className={classes.value}>
            {this.state.version}
          </Typography>

          <Typography variant="overline" className={classes.label}>
            API
          </Typography>
          <Typography variant="body2" className={classes.value}>
            {window._env_.ALLURE_DOCKER_API_URL}
          </Typography>

          <Typography variant="caption" className={classes.attribution}>
            Based on allure-docker-service-ui by Frank Escobar (MIT).
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleReplayIntro} variant="text">
            Replay intro
          </Button>
          <Button onClick={this.handleCloseDialog} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles, { withTheme: true })(AllureDockerInfoDialog);
